// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"dbc07436","623":"0e0d774e","785":"f7d268fe","906":"80b3534b"}[chunkId] + ".css";
};